module.exports = __webpack_public_path__ + "img/meetinginvite.6d66b610.svg";